import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { HeaderNav } from './HeaderNav';
import { ShadowShell } from './ShadowShell';
import { useAuth } from '../../hooks/useAuth';

const IS_ADMIN_SURFACE =
  process.env.REACT_APP_BUILD_TARGET === 'admin'
  || (typeof window !== 'undefined' && window.location.hostname.startsWith('admin.'));
const USE_MODERN_SHELL = typeof window !== 'undefined' && (
  window.location.hostname.startsWith('shadow.')
  || window.location.hostname === 'app.intrlock.io'
  || window.location.hostname === 'admin.intrlock.io'
);

export const Layout: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) return <div className="flex items-center justify-center h-screen"><div className="animate-spin w-8 h-8 border-4 border-brand-600 border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" replace />;

  if (USE_MODERN_SHELL) return <ShadowShell />;

  // Top padding stack on main:
  //   - HeaderNav height: 56 mobile / 112 desktop
  //   - Admin stripe: +28
  const adminExtra = IS_ADMIN_SURFACE ? ' pt-[116px] lg:pt-[156px]' : '';
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <HeaderNav />
      <main className={`flex-1 p-4 lg:p-6 pt-[88px] lg:pt-[128px]${adminExtra}`}>
        <Outlet />
      </main>
    </div>
  );
};
